import { render } from "./AttachmentTask.vue?vue&type=template&id=f7194fb0&scoped=true"
import script from "./AttachmentTask.vue?vue&type=script&lang=js"
export * from "./AttachmentTask.vue?vue&type=script&lang=js"

import "./AttachmentTask.vue?vue&type=style&index=0&id=f7194fb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7194fb0"]])

export default __exports__